module.exports = __webpack_public_path__ + "img/access_controls.4ddf75d9.png";